import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import api from '../services/api'
import FolderManager from './FolderManager';
// import QuizzesManager from './QuizzesManager';
import MembersManager from './MembersManager';

const StudyCircleDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    const [studyCircle, setStudyCircle] = useState(null);
    const [members, setMembers] = useState([]);
    const [folders, setFolders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [activeTab, setActiveTab] = useState('members');
    const [showAddStudentModal, setShowAddStudentModal] = useState(false);
    const [studentSearch, setStudentSearch] = useState('');
    const [studentSearchType, setStudentSearchType] = useState('username');

    useEffect(() => {
        fetchStudyCircleDetails();
    }, [id]);

    const fetchStudyCircleDetails = async () => {
        try {
            const [circleResponse, membersResponse, foldersResponse] = await Promise.all([
                api.get(`/api/study-circles/${id}`),
                api.get(`/api/study-circles/${id}/members`),
                api.get(`/api/study-circles/${id}/folders`)
            ]);

            setStudyCircle(circleResponse.data);
            setMembers(membersResponse.data);
            setFolders(foldersResponse.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to fetch study circle details');
            console.error('Error fetching study circle details:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleAddStudent = async (e) => {
        e.preventDefault();
        try {
            const data = {
                [studentSearchType]: studentSearch
            };
            await api.post(`/api/study-circles/${id}/add-student`, data);
            setShowAddStudentModal(false);
            setStudentSearch('');
            // Refresh members list
            const response = await api.get(`/api/study-circles/${id}/members`);
            setMembers(response.data);
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to add student');
            console.error('Error adding student:', err);
        }
    };

    if (loading) {
        return <div className="text-center mt-5">Loading...</div>;
    }

    if (error) {
        return <div className="alert alert-danger mt-5">{error}</div>;
    }

    if (!studyCircle) {
        return <div className="alert alert-danger mt-5">Study circle not found</div>;
    }

    return (
        <div className="container mt-4">
            <div className="card mb-4">
                <div className="card-body">
                    <h2>{studyCircle.name}</h2>
                    <div
                        className="text-muted"
                        dangerouslySetInnerHTML={{ __html: studyCircle.description }}
                    />
                </div>
            </div>

            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'members' ? 'active' : ''}`}
                        onClick={() => setActiveTab('members')}
                    >
                        👥 Members
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'folders' ? 'active' : ''}`}
                        onClick={() => setActiveTab('folders')}
                    >
                        📂 Folders
                    </button>
                </li>
                
            </ul>

            {/* {activeTab === 'quizzes' && (
                <QuizzesManager studyCircleId={id} folders={folders} />
            )} */}

            {activeTab === 'members' && (
                <MembersManager 
                    studyCircleId={id} 
                    members={members} 
                    onMembersUpdate={setMembers}
                />
            )}

            {activeTab === 'folders' && (
                <FolderManager 
                    studyCircleId={id} 
                    onFoldersUpdate={setFolders}
                />
            )}

            <Modal show={showAddStudentModal} onHide={() => setShowAddStudentModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Student</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleAddStudent}>
                        <Form.Group className="mb-3">
                            <Form.Label>Search by</Form.Label>
                            <Form.Select
                                value={studentSearchType}
                                onChange={(e) => setStudentSearchType(e.target.value)}
                            >
                                <option value="username">Username</option>
                                <option value="email">Email</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Enter {studentSearchType}</Form.Label>
                            <Form.Control
                                type="text"
                                value={studentSearch}
                                onChange={(e) => setStudentSearch(e.target.value)}
                                placeholder={`Enter ${studentSearchType}`}
                                required
                            />
                        </Form.Group>
                        <div className="d-flex justify-content-end">
                            <button type="submit" className="btn btn-primary">
                                Add Student
                            </button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default StudyCircleDetails; 